import { defineComponent } from "vue";

interface UrlQueryWatcher {
  name: string;
  type: "string" | "date" | "json" | "boolean";
}

export default defineComponent({
  data() {
    return {
      urlQueryWatchers: [] as UrlQueryWatcher[],
      isInitUrlQuery: true,
    };
  },

  mounted() {
    if ((this as any).isWaitingLoadInit) {
      return;
    } else {
      this.setUrlQueryData();
    }
  },

  methods: {
    watchingData() {
      for (const item of this.urlQueryWatchers) {
        const { name, type } = item;
        this.$watch(`${name}`, () => this.updateUrlQuery(name, type), { deep: true });
      }
    },

    setUrlQueryData() {
      if (this.isInitUrlQuery) {
        this.isInitUrlQuery = false;
        this.watchingData();
      }
      const urlParams = new URLSearchParams(window.location.search);
      for (const item of this.urlQueryWatchers) {
        const { name, type } = item;
        try {
          if (urlParams.has(name)) {
            if (type === "string") this.setValue(this, name, urlParams.get(name));
            else if (type === "date") this.setValue(this, name, new Date(urlParams.get(name) as string));
            else this.setValue(this, name, JSON.parse(urlParams.get(name) as string));
          }
        } catch (err) {
          console.error(`Error parsing URL param for ${name}:`, err);
        }
      }
    },

    updateUrlQuery(name: string, type: "string" | "date" | "json" | "boolean") {
      const urlParams = new URLSearchParams(window.location.search);
      const value = this.getValue(this, name);
      if (type === "string" || type === "date") urlParams.set(name, value);
      else urlParams.set(name, JSON.stringify(value));

      const queryUrl = urlParams.toString();
      history.replaceState({}, "", `${window.location.pathname}?${queryUrl}`);
    },

    setValue(obj: any, path: string, value: any): void {
      const a = path.split(".");
      let o = obj;
      while (a.length - 1) {
        const n: string = a.shift() || "";
        if (!(n in o)) o[n] = {};
        o = o[n];
      }
      o[a[0]] = value;
    },

    getValue(obj: any, path: string): any {
      path = path.replace(/\[(\w+)\]/g, ".$1");
      path = path.replace(/^\./, "");
      const a = path.split(".");
      let o = obj;
      while (a.length) {
        const n: string = a.shift() || "";
        if (!(n in o)) return undefined;
        o = o[n];
      }
      return o;
    },
  },
});
